import { ICommand, IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { StudentValueModel } from '../../global/components/student_value/model/student_value_model';
import { RouterHelper } from '../../global/helpers/router_helper';
import { FeedbackSuggestedPlanModel } from '../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
import { PlanFeedbackServant } from '../../suggestions/components/plan_feedback/servants/plan_feedback_servant';

angular
  .module('capability-ng-academic-planner')
  .service(
    'preventAccessToPlannerCommand',
    (
      ngPreviewTermPlanConstant: ng.IServiceProvider,
      appConfigModel: any,
      loadSuggestedPlanStatusCommand: ICommand,
      ngStudentValueModel: StudentValueModel,
      ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
      defineCommandORM: IDefineCommand,
      routerHelper: RouterHelper
    ) => {
      return defineCommandORM('preventAccessToPlannerCommand', (deferred) => {
        // using finally here as this api call might fail and throw 400,
        // which is acceptable
        loadSuggestedPlanStatusCommand().finally(() => {
          const suggestedPlan = ngFeedbackSuggestedPlanModel.read();
          const hasUnresolvedSuggestionsExist =
            PlanFeedbackServant.isPlanSentToStudent(suggestedPlan) ||
            PlanFeedbackServant.isPlanCommitedAndBlocked(suggestedPlan);
          if (hasUnresolvedSuggestionsExist) {
            return routerHelper.navigateFromRouter(deferred, 'my.planner.suggestions');
          }

          const apPlanPreviewShownKey = ngPreviewTermPlanConstant['AP_PREVIEW_AUTO_GENERATED_TERM_PLAN_SHOWN'];
          const showAutoGeneratedPlan =
            appConfigModel.isFeatureEnabled('academicplan-allow_autoloading_plan') &&
            !ngStudentValueModel.getBooleanValueByKey(apPlanPreviewShownKey);
          if (showAutoGeneratedPlan) {
            return routerHelper.navigateFromRouter(deferred, 'my.planner.preview_plan.auto_generated');
          }
          return routerHelper.navigateFromRouter(deferred);
        });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/re_route_strategies/prevent_access_to_planner_command.ts